<div class="key-value-item" *ngIf="data">
  <div class="key-value-item__key">{{data.key}}</div>
  <div class="key-value-item__value">{{data.value}}</div>
</div>
